import { createContext, useContext, useReducer, ReactNode } from "react"
import { User } from "@hfc/shared/typings/User"
import { Provider } from "@ethersproject/providers"
import { ethers } from "ethers"

export { default as GameController } from "./GameController"

const defaultRPC = process.env.NEXT_PUBLIC_RPC_URL ?? null
const defaultWSS = process.env.NEXT_PUBLIC_WSS_URL ?? null

/**
 * Howdy Games state
 */
export interface GameState {
	dispatch: Dispatch

	isInitialized: boolean
	provider: Provider
	rpc: string
	wss: string
	/**
	 * e.g. Polygon
	 */
	blockchain: string
	/**
	 * e.g. Mainnet, Mumbai
	 */
	network: string

	user?: User

	isModalOpen: boolean
}

const defaultState: GameState = {
	dispatch: null,

	isInitialized: false,
	provider: new ethers.providers.JsonRpcProvider(defaultRPC),
	rpc: defaultRPC,
	wss: defaultWSS,
	blockchain: process.env.NEXT_PUBLIC_BLOCKCHAIN ?? null,
	network: process.env.NEXT_PUBLIC_BLOCKCHAIN_NETWORK ?? null,

	user: null,

	isModalOpen: false,
}

/**
 * Reducer
 */
export type ActionType =
	| "SET_IS_INITIALIZED"
	| "SET_MODAL_OPEN"
	| "SET_MODAL_CLOSE"
interface Action<T = null> {
	type: ActionType
	payload?: T
}
export type Dispatch = (action: Action) => void

const reducer = (state: GameState, action: Action) => {
	const {
		type,
		// payload
	} = action

	switch (type) {
		case "SET_IS_INITIALIZED":
			return {
				...state,
				isInitialized: true,
			}
		case "SET_MODAL_OPEN":
			return {
				...state,
				isModalOpen: true,
			}
		case "SET_MODAL_CLOSE":
			return {
				...state,
				isModalOpen: false,
			}

		default:
			console.error(`Action "${type}" is undefined!`)
			return state
	}
}

const Game = createContext(defaultState)

/**
 *
 * Provider & consumer
 */
interface GameProviderProps {
	children: ReactNode
}

export const GameProvider = ({ children }: GameProviderProps) => {
	const [state, dispatch] = useReducer(reducer, defaultState)

	const value = { ...state, dispatch }

	return <Game.Provider value={value}>{children}</Game.Provider>
}

export const useHowdyGames = () => useContext(Game)

export default Game
